import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as validate from 'utils/validation';
import { sendInvite } from 'redux/modules/teamManagement';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import { GrayButton, SecondaryButton, Spinner } from 'components';
import * as styles from './NewUserDialog.scss';
var NewUserDialog = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    partnerDetails: state.teamManagement.partnerDetails,
    theme: state.theme
  };
}, {
  sendInvite: sendInvite
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(NewUserDialog, _Component);

  var _super = _createSuper(NewUserDialog);

  function NewUserDialog(props) {
    var _this;

    _classCallCheck(this, NewUserDialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleAddTeamMemberClick", function () {
      _this.setState({
        modalOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextFieldChange", function (e) {
      _this.setState(_defineProperty({}, e.target.id, e.target.value), function () {
        // if email is in error state, check on every keystroke
        if (_this.state.emailInvalid) {
          if (validate.email(_this.state.email) === undefined) {
            _this.setState({
              emailInvalid: false,
              emailErrorMessage: 'Email must be valid.'
            });
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalClose", function () {
      _this.setState({
        invitationSent: false,
        email: '',
        firstName: '',
        lastName: ''
      });

      _this.props.onRequestClose();
    });

    _defineProperty(_assertThisInitialized(_this), "handleInvite", function () {
      _this.setState({
        invitationSending: true
      });

      if (_this.state.email !== '' && validate.email(_this.state.email) === undefined) {
        _this.props.sendInvite(_this.props.userType === 'User' ? _this.props.organization.id : _this.props.theme.org, _this.state.email, _this.state.firstName, _this.state.lastName).then(function () {
          _this.setState({
            invitationSending: false,
            invitationSent: true
          });
        })["catch"](function (err) {
          console.error(err);

          _this.setState({
            emailInvalid: true,
            emailErrorMessage: err && err.error && err.error.message ? err.error.message : 'Email already registered.',
            invitationSending: false
          });
        });
      } else {
        _this.setState({
          emailInvalid: true,
          invitationSending: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInviteMore", function () {
      _this.setState({
        invitationSent: false,
        email: '',
        firstName: '',
        lastName: ''
      });
    });

    _this.state = {
      invitationSent: false,
      invitationSending: false,
      emailInvalid: false,
      email: '',
      firstName: '',
      lastName: '',
      emailErrorMessage: 'Email must be valid.'
    };
    return _this;
  }

  _createClass(NewUserDialog, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.prePopulate) {
        this.setState({
          email: nextProps.email,
          firstName: nextProps.firstName,
          lastName: nextProps.lastName
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var firstStepActions = this.state.invitationSending ? [] : [function (ctx) {
        return /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(GrayButton, {
          label: "Cancel",
          onClick: _this2.handleModalClose,
          style: {
            marginRight: 12
          }
        }));
      }, function (ctx) {
        return /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(SecondaryButton, {
          label: "Invite",
          onClick: _this2.handleInvite
        }));
      }];
      var secondStepActions = [];

      if (this.props.userType === 'User') {
        secondStepActions.push(function (ctx) {
          return /*#__PURE__*/React.createElement(Provider, {
            store: ctx.store
          }, /*#__PURE__*/React.createElement(GrayButton, {
            label: "Invite More People",
            onClick: _this2.handleInviteMore,
            style: {
              "float": 'left'
            }
          }));
        });
      }

      if (this.props.userType !== 'User' && this.props.partnerDetails && parseInt(this.props.partnerDetails.totals.teamMembersRemaining) > 0) {
        secondStepActions.push(function (ctx) {
          return /*#__PURE__*/React.createElement(Provider, {
            store: ctx.store
          }, /*#__PURE__*/React.createElement(GrayButton, {
            label: "Invite More People",
            onClick: _this2.handleInviteMore,
            style: {
              "float": 'left'
            }
          }));
        });
      }

      secondStepActions.push(function (ctx) {
        return /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(SecondaryButton, {
          label: "Done",
          onClick: function onClick() {
            _this2.handleModalClose();

            if (_this2.props.onInviteSubmitted) {
              _this2.props.onInviteSubmitted();
            }
          }
        }));
      });
      var modalBodyContent = null;

      if (this.state.invitationSent || this.state.invitationSending) {
        if (this.state.invitationSending) {
          modalBodyContent = /*#__PURE__*/React.createElement("div", {
            className: styles.modalBodyContent,
            style: {
              minHeight: 75
            }
          }, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } else {
          var formattedName = "".concat(this.state.firstName, " ").concat(this.state.lastName);
          modalBodyContent = /*#__PURE__*/React.createElement("div", {
            className: styles.modalBodyContent
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.modalBodyText
          }, "You've invited a new ".concat(this.props.userType.toLowerCase(), ".")), /*#__PURE__*/React.createElement("div", {
            className: styles.modalBodyTable
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.modalHeaderRow
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.modalHeaderCell
          }, "Email"), /*#__PURE__*/React.createElement("span", {
            className: styles.modalHeaderCell
          }, "Name")), /*#__PURE__*/React.createElement("div", {
            className: styles.modalTableRow
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.modalRowCell
          }, this.state.email), formattedName !== ' ' && /*#__PURE__*/React.createElement("span", {
            className: styles.modalRowCell
          }, formattedName))));
        }
      } else {
        modalBodyContent = /*#__PURE__*/React.createElement("div", {
          className: styles.modalBodyContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.formFieldsWrap
        }, /*#__PURE__*/React.createElement(TextField, {
          className: styles.textField,
          errorText: this.state.emailInvalid ? this.state.emailErrorMessage : '',
          hintText: "name@example.com",
          floatingLabelText: "Email *",
          style: {
            flex: 1,
            minWidth: 225
          },
          value: this.state.email,
          onChange: this.handleTextFieldChange,
          id: "email"
        }), /*#__PURE__*/React.createElement(TextField, {
          className: styles.textField,
          hintText: "",
          floatingLabelText: "First Name",
          style: {
            flex: '0 0 165px'
          },
          value: this.state.firstName,
          onChange: this.handleTextFieldChange,
          id: "firstName"
        }), /*#__PURE__*/React.createElement(TextField, {
          className: styles.textField,
          hintText: "",
          floatingLabelText: "Last Name",
          style: {
            flex: '0 0 165px',
            marginRight: 0
          },
          value: this.state.lastName,
          onChange: this.handleTextFieldChange,
          id: "lastName"
        })));
      }

      return (
        /*#__PURE__*/

        /* What is this? See here: https://stackoverflow.com/a/56765861/3151873 */
        React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
          return /*#__PURE__*/React.createElement(Dialog, {
            actionsContainerStyle: {
              borderTop: 0,
              padding: '5px 20px 20px 20px'
            },
            title: "Add A ".concat(_this2.props.userType),
            titleStyle: {
              color: _this2.props.theme.colors.primaryColor
            },
            actions: _this2.state.invitationSent ? secondStepActions.map(function (a) {
              return a(ctx);
            }) : firstStepActions.map(function (a) {
              return a(ctx);
            }),
            autoScrollBodyContent: true,
            modal: true,
            open: _this2.props.open,
            onRequestClose: _this2.props.onRequestClose,
            bodyStyle: {
              color: '#717171',
              lineHeight: '24px'
            }
          }, /*#__PURE__*/React.createElement(Provider, {
            store: ctx.store
          }, modalBodyContent));
        })
      );
    }
  }]);

  return NewUserDialog;
}(Component), _defineProperty(_class2, "propTypes", {
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired
}), _temp)) || _class);
export default NewUserDialog;